export const resourceRegisterStyles = ({ palette, spacing }) => ({
  rootContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    paddingBottom: 20,
  },
  rowsContainer: {},
  headerContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    minHeight: spacing(5),
    borderBottom: `1px solid ${palette.divider}`,
    padding: `0 ${spacing()} 0 ${spacing(3.5)}`,
  },
  baseRowHead: {
    display: 'flex',
    marginRight: spacing(2),
    color: palette.text.primary,
  },
  firstRowHead: {
    marginLeft: 12,
  },
  alignmentRowHead: {
    paddingLeft: 42,
  },
  smartSearchNoBorder: {
    '&.open': {
      width: '94%',
      borderRadius: 4,
      border: 'none',
      borderColor: palette.border.main,
      background: palette.background.paper,
      margin: '5px 0',
    },
  },
  smartSearch: {
    '&.open': {
      width: '94%',
      border: '1px solid',
      borderColor: palette.border.main,
      background: palette.background.paper,
      margin: '5px 0',
    },
  },
  checkboxScale: {
    transform: 'scale(1.2)',
  },
});

export const treeNodeRowStyles = (theme) => ({
  listContainer: {
    padding: 0,
  },
  collapseContainer: {
    backgroundColor: theme.palette.background.paper,
    '&.narrowMode': {
      marginLeft: 11,
    },
  },
});

export const ResourceRowStyles = (
  { applyOpacityToHex, spacing, transitions, typography, palette, mode },
  _props,
  classes,
) => ({
  listContainer: {
    padding: 0,
  },
  itemContainer: {
    padding: 0,
    position: 'relative',
    // minHeight: spacing(6.5),
    transition: transitions.create(['background', 'border-left-color', 'box-shadow'], {
      duration: transitions.shorter,
    }),
    '&:hover': {
      background: palette.action.hover,
      [`& .${classes.hoverIcon}`]: {
        opacity: 1,
      },
    },
  },
  itemContainerIsEditing: {
    backgroundColor: palette.background.paper,
  },
  itemContentContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
    '&.narrowMode': {
      // paddingLeft: 0,
      padding: 0,
    },
  },
  catName: {
    flex: '3 1 3%',
  },
  catType: {
    display: 'flex',
    flex: '2 1 3%',
  },
  listItemText: {
    ...typography.body1,
    padding: 0,
    marginRight: spacing(2),
    cursor: 'pointer',
    minWidth: spacing(5),
    minHeight: spacing(2.25),
  },
  listItemTextParagraph: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  listItemTextSubCat: {
    ...typography.body1,
    display: 'flex',
    marginRight: spacing(2),
    cursor: 'pointer',
    minWidth: spacing(5),
    minHeight: spacing(2.25),
    borderRadius: 12,
    boxShadow: `0 0 2px 0 ${applyOpacityToHex(palette.secondary.main, 0.6)}`,
    border: `solid 2px ${palette.secondary.main}`,
    backgroundColor: palette.background.default,
    alignItems: 'center',
    padding: '8px 8px 8px 16px',
    flex: 3,
    height: 32,
  },
  listItemTextSubCatParent: {
    ...typography.body1,
    display: 'flex',
    marginRight: spacing(2),
    cursor: 'pointer',
    minWidth: spacing(5),
    minHeight: spacing(2.25),
    borderRadius: 12,
    border: 'solid 2px transparent',
    alignItems: 'center',
    padding: '8px 8px 8px 16px',
    flex: 3,
    height: 32,
  },
  labelHover: {
    ...typography.body1,
    borderRadius: 12,
    padding: '8px 8px 8px 16px',
    border: '2px solid transparent',
    '&:hover': {
      height: 32,
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.background.default,
      border: `2px solid ${palette.border.main}`,
      [`& .${classes.firstItemNoChildren}`]: {
        borderLeftColor: 'transparent',
      },
    },
  },
  labelNoHover: {
    ...typography.body1,
    borderRadius: 12,
    padding: '8px 8px 8px 16px',
    border: '2px solid transparent',
    '&:hover': {
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: '2px solid transparent',
      [`& .${classes.firstItemNoChildren}`]: {
        borderLeftColor: 'transparent',
      },
    },
  },
  noCursorPointer: {
    cursor: 'default',
  },
  textField: {
    ...typography.body1,
    borderRadius: 12,
    boxShadow: `0 0 2px 0 ${applyOpacityToHex(palette.secondary.main, 0.6)}`,
    border: `solid 2px ${palette.secondary.main}`,
    backgroundColor: palette.background.default,
    alignItems: 'center',
    padding: '8px 8px 8px 16px',
    flex: 3,
    height: 32,
  },
  typeTextField: {
    ...typography.body1,
    borderRadius: 12,
    boxShadow: `0 0 2px 0 ${applyOpacityToHex(palette.secondary.main, 0.6)}`,
    border: `solid 2px ${palette.secondary.main}`,
    backgroundColor: palette.background.default,
    paddingLeft: 16,
    flex: 3,
    height: 34,
  },
  selectField: {
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  uneditableCat: {
    padding: '8px 8px 8px 16px',
    border: '2px solid transparent',
    marginRight: 16,
  },
  widthHundred: {
    width: '100%',
  },
  overflowing: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  firstItem: {
    marginLeft: spacing(2),
  },
  firstItemNoChildren: {
    paddingLeft: spacing(3 / 4),
    borderLeft: `2px solid ${palette.border.light}`,
    marginLeft: spacing(3),
  },
  ...(() => {
    const obj = {};
    const maxLevel = 15;
    Array.from(Array(maxLevel), (x, i) => {
      const level = i + 2;

      obj[`itemIdent-L${level}`] = {
        paddingLeft: spacing(3 / 4),
        borderLeft: `2px solid ${palette.border.light}`,
        marginLeft: '8px',
      };
      return null;
    });
    return obj;
  })(),
  collapseIcon: {
    // minWidth: 24,
    width: 24,
    borderRadius: '50%',
    filter: mode === 'light' ? 'none' : 'invert(1)',
  },
  hoverIcon: {
    opacity: 0,
    transition: transitions.create(['opacity'], { duration: transitions.shortest }),
  },
  deleteIcon: {
    color: palette.error.main,
  },
  cancelIcon: {
    color: palette.icon.main,
  },
  saveIcon: {
    color: palette.primary.main,
  },
  actionsIconsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    minWidth: spacing(17.5),
  },
  actionsSelectContainer: {
    display: 'flex',
  },
  editButtonsContainer: {
    display: 'flex',
  },
});

export const DeleteDialogStyles = ({ typography, spacing }) => ({
  bold: {
    fontWeight: typography.fontWeightMedium,
  },
  label: {
    color: 'inherit',
  },
  formLabel: {
    alignItems: 'flex-start',
    marginLeft: 0,
    width: '100%',
  },
  select: {
    height: spacing(3.75),
    '& div': {
      height: '100% !important',
      width: '100%',
    },
  },
  selectText: {
    paddingLeft: spacing(1),
  },
});
